import { ExperienceAvailabilityCalculatePriceOutputDto } from '@abg/shared/dtos';

export const getLimitedMilesText = (
  t: (key: string) => string,
  currency?: string,
  periodFreeMiles?:
    | ExperienceAvailabilityCalculatePriceOutputDto['rateTerms']['periodFreeMiles']
    | {
        values?: [string, string];
        unit?: string;
      }
    | null,
) => {
  // Generates the label to display for the mileage being offered

  if (
    !periodFreeMiles?.values?.[0] ||
    !periodFreeMiles?.values?.[1] ||
    !periodFreeMiles?.unit
  ) {
    // return if no data is present inside the periodFreeMiles object
    return null;
  }
  let prefix = '';
  // Add prefix for no kilometers or miles
  if (periodFreeMiles.values[0] === '0') {
    prefix = t('global.field.no.label'); // No Mileage scenario
  }

  const unitKey =
    (periodFreeMiles.unit === 'KMS' && 'lbl.res.mileage.km') ||
    'lbl.res.mileage.mile';
  const perUnitKey =
    (periodFreeMiles.unit === 'KMS' && 'lbl.res.mileage.perKilometer') ||
    'lbl.res.mileage.perMile';

  const message = `${prefix || Number.parseInt(periodFreeMiles.values[0], 10)} ${t(unitKey)}, ${Number.parseFloat(periodFreeMiles.values[1]).toFixed(2)} ${currency} ${t(perUnitKey)}`;
  return message;
};
